import React from 'react';
import PropTypes from 'prop-types';
import paymethodcheck from 'images/payment/accepted.svg';
import 'styles/components/purchase/InstallmentsSelectedPlan';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'utils/currency';
import useCurrencyConfig from 'hooks/whitelabel/useCurrencyConfig';
import { Button, Icon, Spacing, Text } from '@reservamos/elements';
import LocalizedCurrency from 'components/LocalizedCurrency';

const propTypes = {
  selectedInstallmentsPlan: PropTypes.shape({
    months: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    monthlyPayment: PropTypes.number.isRequired,
    interestByMonth: PropTypes.number.isRequired,
  }).isRequired,
  onChangeClick: PropTypes.func.isRequired,
};

/**
 * InstallmentsSelectedPlan component.
 * This component is used to display the selected installments plan.
 * @param {object} props - selectedInstallmentsPlan, onChangeClick
 * @param {object} props.selectedInstallmentsPlan - Selected installments plan
 * @param {function} props.onChangeClick - Function to be called when the change number of terms button is clicked
 */
const InstallmentsSelectedPlan = ({ selectedInstallmentsPlan, onChangeClick }) => {
  const { t } = useTranslation('purchase');
  const { currency, locale, decimals } = useCurrencyConfig();
  const { months, total, monthlyPayment, interestByMonth } = selectedInstallmentsPlan;
  const selectedPlanLabel = interestByMonth > 0 ? 'text.payments' : 'text.payments_no_interest';
  const formattedMonthlyPayment = formatCurrency(monthlyPayment, decimals, currency, locale);

  return (
    <Spacing vertical>
      <Spacing fullWidth justifyContent="space-between" alignItems="center">
        <Text weight="semibold">
          {t(selectedPlanLabel, {
            months,
            monthlyPayment: formattedMonthlyPayment,
          })}
        </Text>
        <Button isRounded onClick={onChangeClick} padding="S">
          {t('link.change_number_of_terms')}
        </Button>
      </Spacing>

      <div className="installments-selected-plan">
        <Spacing fullWidth alignItems="center" size="S">
          <Icon size="S" type={paymethodcheck} />
          <Spacing justifyContent="space-between" alignItems="flex-end" fullWidth>
            <div>
              <Text mobileSize="S" weight="bold">
                {`${months} ${t('payment:payments_of')} `}
              </Text>
              <LocalizedCurrency
                weight="regular"
                price={monthlyPayment}
                currencyStyle="currency"
                mobileSize="S"
              />
            </div>
            <Text mobileSize="S">
              Total <LocalizedCurrency price={total} currencyStyle="currency" mobileSize="S" />
            </Text>
          </Spacing>
        </Spacing>
      </div>
    </Spacing>
  );
};

InstallmentsSelectedPlan.propTypes = propTypes;

export default InstallmentsSelectedPlan;
